import APIUrl from "../../APIUrl";
import axios from "axios";

export const GET_PRODUCTS_FAMILIES = "GET_PRODUCTS_FAMILIES";

export function getProductsFamiliesAction(productsFamilies) {
  return { type: GET_PRODUCTS_FAMILIES, productsFamilies: productsFamilies };
}

export const getFamiliesPaginated = function (page, limit, searchQuery) {
  return function (dispatch) {
    return axios
      .get(APIUrl.getFamiliesPaginated, {
        params: { page, limit, searchQuery },
      })
      .then(function (response) {
        dispatch(getProductsFamiliesAction(response.data));
      })
      .catch(function (err) {
        throw err;
      });
  };
};

export const getFamiliesCount = function (successCallback) {
  return function (dispatch) {
    return axios
      .get(APIUrl.getFamiliesCount)
      .then(function (response) {
        return successCallback(response.data);
      })
      .catch(function (err) {
        throw err;
      });
  };
};

export const isProductFamilyKeywordAlreadyExists = function (
  keyword,
  existsCallback,
  noExistsCallback,
) {
  return function () {
    return axios
      .get(
        APIUrl.isProductFamilyKeywordAlreadyExists +
          encodeURIComponent(keyword),
      )
      .then(function (response) {
        if (response.status === 200) {
          if (existsCallback) existsCallback();
        } else {
          if (noExistsCallback) noExistsCallback();
        }
      });
  };
};

export const addProductFamily = function (data, successCallback) {
  return function (dispatch) {
    return axios
      .post(APIUrl.addProductFamily, data)
      .then(function (response) {
        if (successCallback) return successCallback(response.data);
      })
      .catch(function (err) {
        console.log(err);
        throw err;
      });
  };
};

export const updateProductFamily = function (data, successCallback) {
  return function (dispatch) {
    return axios
      .post(APIUrl.updateProductFamily, data)
      .then(function (response) {
        if (response) if (successCallback) return successCallback();
      })
      .catch(function (err) {
        console.log(err);
        throw err;
      });
  };
};

export const deleteProductFamily = function (data, successCallback) {
  return function (dispatch) {
    return axios
      .post(APIUrl.deleteProductFamily, data)
      .then(function (response) {
        if (successCallback) return successCallback();
      })
      .catch(function (err) {
        console.log(err);
        throw err;
      });
  };
};

// IMG

export const addProductFamilyImage = function (
  familyId,
  data,
  successCallback,
) {
  return function (dispatch) {
    return axios
      .post(APIUrl.addProductFamilyImage + familyId, data, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then(function () {
        if (successCallback) return successCallback();
      })
      .catch(function (err) {
        console.log(err);
        throw err;
      });
  };
};
